import { useEffect, useState } from "react";
import Table from "../../components/Table/Table";
import { FaUserTie } from "react-icons/fa";
import { tableConstants } from "./ClassTeacherTableConstant";
import Loader from "../../components/Loader/Loader";
import { enqueueSnackbar } from "notistack";
import {
  getClassTeachers,
  createClassTeacher,
  updateClassTeacher,
} from "../../services/ClassTeacherService";
import { getUsers } from "../../services/UserService";
import CardHeader from "../../components/Card/CardHeader";
import ClassTeacherForm from "./ClassTeacherForm";

const ClassTeacherList = () => {
  const [data, setData] = useState([]);
  const [teacherList, setTeacherList] = useState([]);
  const [isLoader, setIsLoader] = useState(false);

  // modal state
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [formData, setFormData] = useState({
    id: "",
    program_id: "",
    user_id: "",
    class_in_charge_id: "",
    commencement_date: "",
  });

  const permissions = JSON.parse(localStorage.getItem("permissions"));
  /**
   * Fetch class teachers
   */
  const fetchData = async () => {
    try {
      setIsLoader(true);

      const response = await getClassTeachers();

      if (response.data.success) {
        setData(response.data.data);
      }
    } catch (error) {
      enqueueSnackbar("Failed to fetch data", {
        variant: "error",
      });
    } finally {
      setIsLoader(false);
    }
  };

  /**
   * Fetch teachers
   */
  const fetchTeachers = async () => {
    try {
      const response = await getUsers({
        name: "",
        page: 1,
        pageSize: 500,
      });

      if (response.success) {
        setTeacherList(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchData();
    fetchTeachers();
  }, []);

  /**
   * Open modal for create or edit
   */
  const openModal = (row = null) => {
    if (row) {
      setFormData({
        id: row.id,
        program_id: row.program_id,
        user_id: row.teacher?.id || "",
        class_in_charge_id: row.class_in_charge?.id ?? "",
        commencement_date: row.commencement_date ?? "",
      });
    } else {
      setFormData({
        id: "",
        program_id: "",
        user_id: "",
        class_in_charge_id: "",
        commencement_date: "",
      });
    }
    setIsModalOpen(true);
  };

  /**
   * Close modal
   */
  const closeModal = () => {
    setIsModalOpen(false);
  };

  /**
   * Handle form change
   */
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  /**
   * Save class teacher
   */
  const handleSave = async () => {
    try {
      if (!formData.program_id || !formData.user_id) {
        enqueueSnackbar("Please select teacher", {
          variant: "warning",
        });

        return;
      }

      let response;
      if (formData.id) {
        response = await updateClassTeacher(formData.id, formData);
      } else {
        response = await createClassTeacher(formData);
      }

      if (response.data.success) {
        enqueueSnackbar(response.data.message, {
          variant: "success",
        });

        closeModal();
        fetchData();
      }
    } catch (error) {
      enqueueSnackbar("Failed to save", {
        variant: "error",
      });
    }
  };

  return (
    <>
      {isLoader && <Loader />}

      <div className="card">
        <CardHeader title="Class Teacher List" icon={<FaUserTie />} />
        <div className="card-body">
          <Table cols={tableConstants(openModal, permissions)} data={data} />
        </div>
      </div>
      <ClassTeacherForm
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        formData={formData}
        teacherList={teacherList}
        handleChange={handleChange}
        handleSave={handleSave}
      />
    </>
  );
};

export default ClassTeacherList;
